import { render, staticRenderFns } from "./StatisticsNumber.vue?vue&type=template&id=4f5d4e06&scoped=true"
import script from "./StatisticsNumber.vue?vue&type=script&lang=js"
export * from "./StatisticsNumber.vue?vue&type=script&lang=js"
import style0 from "./StatisticsNumber.vue?vue&type=style&index=0&id=4f5d4e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d4e06",
  null
  
)

export default component.exports